import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/footer/logo_ifen_footer.svg")